import {StyleSheet} from 'react-native';
import {colorPalette} from '../../../../../theme';

export default StyleSheet.create({
  scrollStyle: {
    flex: 1,
  },
  scroll: {
    flex: 1,
  },
  icon: {
    alignSelf: 'center',
    marginTop: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reason: {
    alignSelf: 'stretch',
    backgroundColor: colorPalette.grey0_5,
    borderRadius: 18,
    marginVertical: 12,
    paddingVertical: 12,
    marginHorizontal: 16,
    paddingHorizontal: 16,
  },
  instruction: {
    alignSelf: 'stretch',
    backgroundColor: colorPalette.grey0_5,
    borderRadius: 18,
    marginBottom: 12,
    paddingTop: 12,
    marginHorizontal: 16,
    paddingHorizontal: 16,
  },
});
